import React from "react";
import { Typography, Button } from "@mui/material";

const Footer = ({ darkMode }) => {
  return (
    <footer
      style={{
        backgroundColor: darkMode ? "#1d1d1d" : "#f9f9f9",
        color: darkMode ? "#ffffff" : "#000000",
        padding: "20px",
        marginTop: 0, // Remove o espaçamento no topo
        textAlign: "center",
        borderTop: "none", // Remove a borda no topo
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        {/* Informações de Contato */}
        <div>
          <Typography
            variant="h6"
            style={{
              marginBottom: "10px",
              borderBottom: `2px solid ${darkMode ? "#ffffff" : "#000000"}`,
              paddingBottom: "5px",
            }}
          >
            Contato
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            {/* Ícone de E-mail */}
            <a
              href="mailto:suporte@codefort.com.br"
              style={{
                color: darkMode ? "#ffffff" : "#000000",
                textDecoration: "none",
              }}
            >
              <img
                src="https://img.icons8.com/material-rounded/24/email.png"
                alt="E-mail"
                style={{
                  filter: darkMode ? "invert(1)" : "none",
                  transition: "filter 0.3s",
                }}
              />
            </a>
            {/* Ícone de WhatsApp */}
            <a
              href="https://wa.me/5511969585573"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: darkMode ? "#ffffff" : "#000000",
                textDecoration: "none",
              }}
            >
              <img
                src="https://img.icons8.com/material-rounded/24/whatsapp.png"
                alt="WhatsApp"
                style={{
                  filter: darkMode ? "invert(1)" : "none",
                  transition: "filter 0.3s",
                }}
              />
            </a>
          </div>
        </div>

        {/* Botão de Localização */}
        <div>
          <Typography
            variant="h6"
            style={{
              marginBottom: "10px",
              borderBottom: `2px solid ${darkMode ? "#ffffff" : "#000000"}`,
              paddingBottom: "5px",
            }}
          >
            Localização
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            onClick={() =>
              window.open(
                "https://www.google.com/maps/place/Av.+Paulista,+1106+-+Sala+01+-+16+andar+-+Bela+Vista,+S%C3%A3o+Paulo+-+SP,+01310-914/@-23.5641342,-46.6550706,17z/data=!3m1!4b1!4m6!3m5!1s0x94ce59c7de36fec1:0x1fac442c2adb2d2e!8m2!3d-23.5641342!4d-46.6524957!16s%2Fg%2F11w3x_n00z?entry=ttu&g_ep=EgoyMDI0MTIwNC4wIKXMDSoASAFQAw%3D%3D",
                "_blank"
              )
            }
            style={{
              borderColor: darkMode ? "#ffffff" : "#1d4f91",
              color: darkMode ? "#ffffff" : "#1d4f91",
              transition: "all 0.3s",
            }}
          >
            Ver no Mapa
          </Button>
        </div>

        {/* Direitos Autorais */}
        <div>
          <Typography
            variant="h6"
            style={{
              marginBottom: "10px",
              borderBottom: `2px solid ${darkMode ? "#ffffff" : "#000000"}`,
              paddingBottom: "5px",
            }}
          >
            © {new Date().getFullYear()} CodeFort
          </Typography>
          <Typography variant="body2" style={{ transition: "color 0.3s" }}>
            Todos os direitos reservados.
          </Typography>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
